import * as React from "react";

import { DataSourceMyBagControllerProvider } from "./data-source--mybag-controller-provider";

export const DataSourceMyBagProvider: React.FunctionComponent = (props) => {
  return (
    <DataSourceMyBagControllerProvider>
      {props?.children || []}
    </DataSourceMyBagControllerProvider>
  );
};
